

export function getUserTheme() {
    // Check the user's preferred color scheme
    const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (isDarkMode) {
        // console.log('The user prefers dark mode.');
        return 'dark'
    } else {
        console.log('The user prefers light mode.');
        return 'light'
    }
}


export function watchTheme(callback) {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    // Listen for changes in the system theme
    mediaQuery.addEventListener('change', (event) => {
        const newTheme = event.matches ? 'dark' : 'light';
        console.log(`The user switched to ${newTheme} mode.`);
        if (typeof callback === 'function') {
            callback(newTheme); 
        }
    });
}

